import { inject, Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

import { AuthService } from '@plugins/client/auth';
import { hasSufficientRoleLevel } from '@plugins/shared/helpers/auth';

/**
 * Enables preloading for admins so they can edit and
 * manage all available translations in the application.
 */

@Injectable({ providedIn: 'root' })
export class AdminPreloadStrategy implements PreloadingStrategy {
  private readonly authService = inject(AuthService);

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (hasSufficientRoleLevel(this.authService.userToken.role, 'admin')) {
      return load();
    }

    return of(null);
  }
}
